

const Titulos = ({titulo, autor, fecha}) => {

    return (
        <>

            <section className="blog-titulos">
                <h1 >{titulo}</h1>
                <p>
                    {autor} · {fecha}
                </p>
            </section>

        </>
    )

}

export default Titulos